import { api } from '@/scripts/api';

export const UpdatesService = {
    getById(id) {
        return new Promise((resolve, reject) => {
            const service = `/ms/notifications/v1/massive-notifications/${id}`;
            api
                .get(service)
                .then(resolve)
                .catch(reject);
        });
    },
    getAll(options = {}) {
        return new Promise((resolve, reject) => {
            const service = `/ms/notifications/v1/massive-notifications?${options}`;
            api
                .get(service)
                .then(resolve)
                .catch(reject);
        });
    },
    cancel(id) {
        return new Promise((resolve, reject) => {
            const service = `/ms/notifications/v1/massive-notifications/${id}/unschedule`;
            api
                .post(service)
                .then(resolve)
                .catch(reject);
        });
    },
    delete(id) {
        return new Promise((resolve, reject) => {
            api
                .delete(`/ms/notifications/v1/massive-notifications/${id}`)
                .then(resolve)
                .catch(reject);
        });
    },
    patch(id, body) {
        return new Promise((resolve, reject) => {
            api
                .msPatch(`/ms/notifications/v1/massive-notifications/${id}`, body)
                .then(resolve)
                .catch(reject);
        });
    },
    post(body) {
        return new Promise((resolve, reject) => {
            api
                .post('/ms/notifications/v1/massive-notifications', body)
                .then(resolve)
                .catch(reject);
        });
    }
}